export const factureBasePath = 'factures';
export const listeFacturesPath = '';
export const detailFacturePath = ':idFacture';
